/*
 * File: d:\projects\AutoFiFront\src\Content\Filter\TextFilters\Filters.tsx
 * Project: d:\projects\AutoFiFront
 * Created Date: Wednesday February 22nd 2023
 * Author: Jonathan Mazat
 * -----
 * Last Modified: Wednesday February 22nd 2023 1:44:32 pm
 * Modified By: the developer formerly known as Jonathan Mazat at <you@you.you>
 * -----
 * Copyright (c) 2023 Autobuy SAS
 * -----
 * HISTORY:
 */

import React from "react";
import SelectStyled from "Theme/Component/SelectStyled";

type FilterProps ={
    icon: string | undefined,
    selectable: {label:string, value: string}[],
    selectFunc: React.ChangeEventHandler<HTMLSelectElement>,
    themeColor: string,
};

function Filter (props:FilterProps) {

    return (
        <React.Fragment>
            <SelectStyled bgColor={props.themeColor} onChange={props.selectFunc} name="type">
                {
                    props.selectable.map((item: {label:string, value: string}, index: number)=> {return <option key={`${item.value}-${index}`} value={`${item.value}`}>{item.label}</option>})
                }
            </SelectStyled>
        </React.Fragment>
    );
}

export default Filter;
